export default __webpack_public_path__ + "logo11fdbdf1.png";